import { clone, getDeepValue, isEqual, isObject, setDeepValue } from "./Misc";
import PubSub from "./PubSub";

export default class StateMgr {
    _internalState: any;

    _pubsub: PubSub;

    constructor(initialState = {}) {
        if (!isObject(initialState)) {
            throw new Error("initial state must be a object");
        }

        this._internalState = clone(initialState);
        this._pubsub = new PubSub();
    }

    get state() {
        return clone(this._internalState);
    }

    // eslint-disable-next-line no-empty-function
    set state(e) {}

    /**
     * Set a state to the state object.
     * @param {any} value - value to set
     * @param {Boolean} force - Forces publish even if value did not change.
     * @returns {Object} - next state object
     */
    setState(value, force) {
        if (!isObject(value)) {
            throw new Error("value must be a object");
        }

        const currentState = clone(this._internalState);
        const nextState = Object.assign(clone(currentState), clone(value));
        this._internalState = nextState;

        const listKeys = Object.keys(value);

        for (let i = 0; i < listKeys.length; i++) {
            const currentValue = getDeepValue(currentState, listKeys[i]);
            const nextValue = getDeepValue(nextState, listKeys[i]);

            if (!isEqual(currentValue, nextValue) || force) {
                this._pubsub.publish(listKeys[i], nextValue);
            }
        }
        return nextState;
    }

    /**
     * Set a state to the state object via item path.
     * @param {String} itemPathName - item path name to set to (ex: car.door)
     * @param {any} value - value to set
     * @param {Boolean} force - Forces publish even if value did not change.
     * @returns {Object} - next state object
     */
    setStateItem(itemPathName, value, force) {
        const currentState = clone(this._internalState);
        const currentValue = getDeepValue(currentState, itemPathName);

        if (currentValue !== undefined) {
            const nextState = clone(this._internalState);
            setDeepValue(nextState, itemPathName, value);
            this._internalState = nextState;

            if (!isEqual(currentValue, value) || force) {
                this._pubsub.publish(itemPathName, value);
            }
            return nextState;
        }

        throw new Error(`Could not find and set itemPathName: ${itemPathName}`);
    }

    /**
     * Subscribe to given state name, will call callback function
     * on state changes.
     *
     * @param {function} callback - Function to callback when item with
     * 								stateName changes
     * @param {String} stateName - state name to subscribe to
     * 								(can be an object path ex: item.name)
     * @returns {Integer} - id of the subscription, to be used for unsubscribe
     */
    subscribe(callback, stateName) {
        return this._pubsub.subscribe(callback, stateName);
    }

    /**
     * Unsubscribe from state change callbacks.
     * @param {Integer} subscriptionId - id to unsubscribe from
     * 									(received on subscribe)
     * @returns {Boolean} - true if found and unsubscribed
     */
    unsubscribe(subscriptionId) {
        return this._pubsub.unsubscribe(subscriptionId);
    }

    clear() {
        this._pubsub._callbackList = {};
    }
}
